export default "/images/vendor/flag-icon-css/flags/4x3/li.svg?69a1d60ca3996705d91f1f4bd4825b5a";